<template>
  <v-menu
    bottom
    offset-y
    :nudge-bottom="8"
    elevation="0"
    transition="slide-y-transition"
    :close-on-content-click="true"
    content-class="request-row-overflow-menu__panel"
    :value="isOpen"
    @input="$emit('toggle', $event)"
    data-testid="request-row-overflow-menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip top content-class="tooltip-top">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <button
            type="button"
            class="request-row-hover-actions__more-btn"
            v-bind="{ ...attrs, ...tooltipAttrs }"
            v-on="{ ...on, ...tooltipOn }"
            data-testid="request-row-overflow-menu__trigger"
            @click.stop
          >
            <img
              :src="icon"
              alt=""
              class="request-row-overflow-menu__trigger-icon"
              width="16"
              height="16"
            />
          </button>
        </template>
        <span>More</span>
      </v-tooltip>
    </template>

    <div class="request-row-overflow-menu" data-testid="request-row-overflow-menu__list">
      <button
        v-for="action in actions"
        :key="action.id"
        type="button"
        class="request-row-overflow-menu__item"
        :data-testid="`request-row-overflow-menu__${action.id}`"
        @click.stop="$emit('action', { actionId: action.id, request })"
      >
        <span class="request-row-overflow-menu__icon-wrap">
          <img
            :src="action.icon"
            alt=""
            class="request-row-overflow-menu__item-icon"
            width="16"
            height="16"
          />
        </span>
        <span class="request-row-overflow-menu__label">{{ action.label }}</span>
      </button>
    </div>
  </v-menu>
</template>

<script>
import './RequestRowOverflowMenu.scss';

export default {
  name: 'RequestRowOverflowMenu',
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    request: {
      type: Object,
      default: () => ({}),
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '/img/icons/fbc-icons/MoreActionsIcon.svg',
    },
  },
};
</script>
